import { render, staticRenderFns } from "./lock-screen.vue?vue&type=template&id=149d61b2&scoped=true&"
import script from "./lock-screen.vue?vue&type=script&lang=js&"
export * from "./lock-screen.vue?vue&type=script&lang=js&"
import style0 from "./lock-screen.vue?vue&type=style&index=0&id=149d61b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d61b2",
  null
  
)

export default component.exports